import { Injectable } from '@angular/core';
import { AuthStore } from '@store';
import { PurchasesMockApi } from '@vi-iot/client/apis/purchases/purchases.mock.api';
import { BaseApiPickerImpl } from '../base.api-picker';
import { PurchasesApi } from './purchases.api';

@Injectable({ providedIn: 'root' })
export class PurchasesApiPicker extends BaseApiPickerImpl<PurchasesApi | PurchasesMockApi> {
  constructor(
    protected authStore: AuthStore,
    protected realApi: PurchasesApi,
    protected mockApi: PurchasesMockApi
  ) {
    super(authStore, realApi, mockApi);
  }
}
